import { makeAutoObservable, runInAction } from 'mobx'

import { serverMessage } from '@/Ship/Helpers/serverError'

import { ChangeUserStatusTask, type UserActivityStatus } from '../Tasks/ChangeUserStatusTask'

/**
 * Перемикач «Активність» картки (ADR 038): запит, очікування й помилка.
 * Один екземпляр на змонтований перемикач.
 */
export class UserStatusManager {
    isLoading = false
    error: string | null = null

    constructor() {
        makeAutoObservable(this)
    }

    /** Новий стан або `null`, якщо бек відмовив (причина — в `error`). */
    async change(uuid: string, status: UserActivityStatus): Promise<UserActivityStatus | null> {
        this.isLoading = true
        this.error = null

        try {
            const response = await ChangeUserStatusTask(uuid, status)
            const saved = response.status === 'active' || response.status === 'inactive' ? response.status : status

            return saved
        } catch (error) {
            runInAction(() => {
                this.error = serverMessage(error, 'Не вдалося змінити активність співробітника.')
            })

            return null
        } finally {
            runInAction(() => {
                this.isLoading = false
            })
        }
    }
}
